import { IEstimate } from 'types/entities';
import { EntityService } from '../entity.service';


class EstimatesService extends EntityService<IEstimate> {
  readonly entityName = 'estimate';
}

export default new EstimatesService();
